import { MessageOperation, RequestOperation } from '@peercolab/engine'
import { SearchInput } from '../../Core/PathItems'
import { Published } from '../Core/PathItems'

export class SearchCommand extends RequestOperation<SearchInput,Command[]> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Commands.SearchCommand",
      "SEARCH",
      ["CommandId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class CreateCommand extends RequestOperation<CreateCommandInput,Command> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Commands.CreateCommand",
      "CREATE",
      ["CommandId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class DeleteCommand extends MessageOperation<object> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Commands.DeleteCommand",
      "DELETE",
      ["CommandId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class UpdateCommandDescription extends MessageOperation<UpdateCommandDescriptionInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Commands.UpdateCommandDescription",
      "PATCH",
      ["CommandId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class UpdateCommandName extends MessageOperation<UpdateCommandNameInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Commands.UpdateCommandName",
      "PATCH",
      ["CommandId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class GetCommand extends RequestOperation<object,Command> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Commands.GetCommand",
      "GET",
      ["CommandId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class UpdateCommandState extends MessageOperation<UpdateCommandStateInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Commands.UpdateCommandState",
      "PATCH",
      ["CommandId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export type Command = {
  id: string
  name: string
  translationKey: string
  description: string
  descriptionTranslationKey: string
  state: Published
}

export type CreateCommandInput = {
  commandId?: string | undefined
  name: string
  description?: string | undefined
}

export type UpdateCommandDescriptionInput = {
  description: string
}

export type UpdateCommandNameInput = {
  name: string
}

export type UpdateCommandStateInput = {
  /**
   * Valid values: publish, unpublish, revert
   */
  stateTransition: string
}

